
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import AccountViewRepository from '@/repositories/accountview/AccountViewRepository';
import { Subscription } from 'rxjs';
import AccountViewStatus from '@/repositories/data/accountview/AccountViewStatus';

@Component({
    components: {
        GeneralScaffold,
    },
})
export default class HomeScreen extends Vue {
    public accountViewLoading = true;
    public accountViewStatus: AccountViewStatus = {
        active: false,
    };

    @Inject()
    private readonly accountViewRepository!: AccountViewRepository;

    private accountViewSubscription = new Subscription();

    public created(): void {
        this.accountViewSubscription = this.accountViewRepository.getStatus().subscribe((resource) => {
            if (resource.isSuccess && resource.data) {
                this.accountViewStatus = resource.data;
            }
            this.accountViewLoading = resource.isLoading;
        });
    }

    public beforeDestroy(): void {
        this.accountViewSubscription.unsubscribe();
    }

    public startAuthenticateFlow(): void {
        this.accountViewSubscription.unsubscribe();
        this.accountViewSubscription = this.accountViewRepository.getAuthenticateFlowStart().subscribe((resource) => {
            if (resource.isSuccess && resource.data) {
                window.location.href = this.accountViewRepository.makeFullAuthenticateUrl(
                    resource.data.authenticatePath,
                );
            }
        });
    }
}
